export const TintColors = [

]
